import * as React from 'react';
import { SVGProps } from 'react';

const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='m14.121 3.121-1.06 1.061 6.677 6.677H2.14v1.495h17.596l-6.676 6.677 1.06 1.06 8.486-8.484L14.12 3.12Z'
      fill='#000'
    />
  </svg>
);

export default SvgArrowRight;
